import { render, staticRenderFns } from "./VoucherUpload.vue?vue&type=template&id=0a38ef64&scoped=true"
import script from "./VoucherUpload.vue?vue&type=script&lang=js"
export * from "./VoucherUpload.vue?vue&type=script&lang=js"
import style0 from "./VoucherUpload.vue?vue&type=style&index=0&id=0a38ef64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a38ef64",
  null
  
)

export default component.exports